var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21425 5.28639L2.21425 0.286388C2.02661 0.0987473 1.77211 -0.00666809 1.50675 -0.00666809C1.24138 -0.00666809 0.986886 0.0987473 0.799246 0.286388C0.611605 0.474029 0.50619 0.728524 0.50619 0.993888C0.50619 1.25925 0.611605 1.51375 0.799246 1.70139L5.09225 5.99439L0.799246 10.2874C0.703735 10.3796 0.627553 10.49 0.575144 10.612C0.522735 10.734 0.495149 10.8652 0.493995 10.998C0.492841 11.1308 0.518143 11.2624 0.568424 11.3853C0.618705 11.5082 0.692958 11.6199 0.786851 11.7138C0.880743 11.8077 0.992395 11.8819 1.11529 11.9322C1.23819 11.9825 1.36987 12.0078 1.50265 12.0066C1.63543 12.0055 1.76665 11.9779 1.88865 11.9255C2.01065 11.8731 2.121 11.7969 2.21325 11.7014L7.21325 6.70139C7.40072 6.51386 7.50603 6.25955 7.50603 5.99439C7.50603 5.72922 7.40072 5.47492 7.21325 5.28739L7.21425 5.28639Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12,
    transform: "translate(8 12) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.32dc06fbe157a094d4fc4221220051c6.svg";
export { ForwardRef as ReactComponent };